module.exports = __webpack_public_path__ + "static/Home4-321dc9a9c833965cfdbe366ed74358c9.jpg";